import {combineReducers} from 'redux';
import home from './home/reducer';
import dashboard from './dashboard/reducer';
import linkbuilder from './linkbuilder/reducer';
import finance from './finance/reducer';
import settings from './settings/reducer';

export default combineReducers({
  home,
  dashboard,
  linkbuilder,
  finance,
  settings,
});
